import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../agrari-styles/menu.css'
import { PrivateComponent } from '../PrivateComponent'

function InventarioMenu({url}) {
    let [activeItem, cambiarActiveItem] = useState("Almacen")

    return (
        <div className="topnav" >
            <PrivateComponent roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']}>
                <Link 
                className={`${activeItem === "Almacen"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Almacen')}
                to={`${url}`}>
                    Almacén
                </Link>
            </PrivateComponent>
            <PrivateComponent roles={['productPurchase']}>
                <Link 
                className={`${activeItem === "Compras"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Compras')}
                to={`${url}/Compras`}>
                    Compras
                </Link>
            </PrivateComponent>
            <PrivateComponent roles={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']}>
                <Link 
                className={`${activeItem === "Orden"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Orden')}
                to={`${url}/OrdenCompra`}>
                    Orden Compra
                </Link>
            </PrivateComponent>
            <PrivateComponent roles ={['warehouseAdmin', 'warehouse', 'farmAdmin']}>
                <Link 
                className={`${activeItem === "Aplicaciones"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Aplicaciones')}
                to={`${url}/Aplicaciones`}>
                    Aplicaciones
                </Link>
            </PrivateComponent>
            <PrivateComponent roles ={['productPurchase']}>
                <Link 
                className={`${activeItem === "Movimientos"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Movimientos')}
                to={`${url}/Movimientos`}>
                    Movimientos
                </Link>
            </PrivateComponent>
            <PrivateComponent roles ={['warehouseAdmin', 'productPurchase', 'warehouse', 'farmAdmin']}>
                <Link 
                className={`${activeItem === "Catalogos"?"active":null}`} 
                onClick={()=>cambiarActiveItem('Catalogos')}
                to={`${url}/Catalogos`}>
                    Catalogo
                </Link>
            </PrivateComponent>
        </div>
    )
}

export default InventarioMenu;